export const showDialog = (dialogId) => {    
    const dialog = document.getElementById(dialogId)
    dialog.showModal()
  };
  export const closeDialog = (dialogId) => {
    const dialog = document.getElementById(dialogId);
    dialog.close()
  };